import { createElement, type ComponentType, type ReactElement } from 'react'
import type { ResolvedComponent } from '@inertiajs/react'
import { Toaster } from 'sonner'

import { ThemeInitializer } from '@/components/theme-initializer'
import i18n from '@/lib/i18n'

const pages = import.meta.glob('../pages/**/*.{jsx,tsx}')

export function resolvePageComponent(name: string) {
  const page = pages[`../pages/${name}.tsx`] || pages[`../pages/${name}.jsx`]

  if (!page) {
    throw new Error(`Missing Inertia page component: ${name}`)
  }

  return page() as Promise<ResolvedComponent>
}

export async function syncPageLocale(page: { props: Record<string, unknown> }) {
  const locale = typeof page.props.locale === 'string' ? page.props.locale : 'en'

  if (i18n.language !== locale) {
    await i18n.changeLanguage(locale)
  }
}

export function syncPageCsrfToken(page: { props: Record<string, unknown> }) {
  const csrfToken = typeof page.props.csrf_token === 'string' ? page.props.csrf_token : null

  if (!csrfToken) {
    return
  }

  const existingMetaTag = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')

  if (existingMetaTag) {
    existingMetaTag.content = csrfToken
    return
  }

  const metaTag = document.createElement('meta')
  metaTag.name = 'csrf-token'
  metaTag.content = csrfToken
  document.head.appendChild(metaTag)
}

export function renderInertiaShell(
  App: ComponentType<any>,
  props: any,
): ReactElement {
  return createElement(
    'div',
    { style: { height: '100%' } },
    createElement(ThemeInitializer),
    createElement(App, props),
    createElement(Toaster, { richColors: true, position: 'top-right' }),
  )
}

export function buildAbsoluteUrl(appUrl: string | undefined, path: string) {
  if (!appUrl) {
    return path
  }

  return new URL(path, appUrl).toString()
}